<template>
  <div class="message-body message-button" v-if="!answered">
    <div class="general-button button-ask-information">
      <div class="widget-button-header">
        <div class="widget-button-header-desc" v-html="markdownToHtml(title) || $t('capture_lead_title')">
        </div>
        <ul class="widget-button-list">
          <li v-for="(item, index) in captureLeads" :key="item.name" v-show="item.display" class="list-question">
            <p class="user-custom-name"><b>{{item.title | capitalize}}</b><span class="rq" v-if="item.state === true">*</span></p>
            <div :id="[item.input_type === 'datetime' ? 'date-picker-dom' : '']" :class="[item.input_type === 'list' ? 'custom-multiple-select' : '', sending || item.answered || answered ? 'disable' : '', isEndedConvo ? 'disable' : '', 'form-style', error ? 'error-input': '']" @keyup="error = false">
              <input type="text" v-model.trim="item.answer" class="text" @keyup.enter="sendAnswer(item.name, item.answer, item.state, item.input_type, index)" :ref="`input_answer_${item.name}`" :placeholder="item.answer ? item.answer : item.placeholder" v-if="item.input_type ==='text' || item.input_type === 'number'" maxlength="100">
              <template v-else-if="item.input_type === 'datetime'">
              <input type="text" id="date-picker" ref="input_date_time" class="flatpickr text" v-model.trim="item.answer"  placeholder='DD-MM-YYYY'>
                <a class="input-button" style="width: 16px; padding-top: 5px; float: left" title="toggle" data-toggle="" @click="showCalendar = !showCalendar" v-if="!isMobile">
                  <v-icon name="calendar" fill="#888"/>
                </a>
              </template>
              <multiselect v-else-if="item.input_type === 'list'"
                v-model="item.answer"
                :options="item.items"
                :close-on-select="true"
                :taggable="false"
                :hide-selected="true"
                :placeholder="$t('select_your_answer')"
                :multiple="true"
                :show-labels="false"
                :searchable="true">
              </multiselect>
              <multiselect v-else-if="item.input_type === 'boolean'"
                v-model="item.answer"
                :options="[{value: $t('true'), key: 'yes'}, {value: $t('false'), key: 'no'}]"
                :close-on-select="true"
                :hide-selected="true"
                :placeholder="$t('select_your_answer')"
                :multiple="false"
                track-by="value"
                label="value"
                :show-labels="false">
              </multiselect>
              <button class="button-form-submit color-theme-default" :class="{sucsess: sucsess, error: error}" @click.stop="sendAnswer(item.name, item.answer, item.state, item.input_type, index)">
                <i v-if="!sucsess && !error" class="backto-list-icon forward"></i>
                <i v-if="sending" class="spinner"></i>
                <v-icon v-if="sucsess" name="check" />
                <v-icon v-if="error" name="undo" />
              </button>
            </div>
          </li>
          <li>
            <div class="step-load" v-show="countAnswer > 0 && !answered">
              <p :class="[index <= stepId ? 'pass-answer': '', 'color-theme-default']" :style="'width:'+ ((1 / captureLeads.length * 100) -1) + '%'" v-for="(step, index) in captureLeads.length" :key="index"></p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import { getMs, isEmail, isNumber, cloneDeep } from '../utils'
import { mapState } from 'vuex'
import bowser from 'bowser'
import { u as umbrella } from 'umbrellajs'
import { markdown } from 'markdown'

const flatpickr = require('flatpickr')
const objectPath = require('object-path')

export default {
  name: 'ask-info',
  props: ['attachments', 'messageId', 'passed'],

  data () {
    return {
      answerList: [],
      countAnswer: 0,
      sending: false,
      error: '',
      answered: false,
      captureLeads: [],
      title: '',
      stepId: 0,
      showCalendar: false,
      sucsess: false
    }
  },

  created () {
    let cloneAnswerList = cloneDeep(objectPath.get(this.attachments, 'form.fields', []))
    this.title = cloneDeep(objectPath.get(this.attachments, 'form.title', ''))
    this.answerList = cloneDeep(cloneAnswerList)
    this.captureLeads = cloneDeep(cloneAnswerList).map(item => this.convertToView(item))
    if (this.captureLeads.length > 0 && !objectPath.get(this.captureLeads, '0.answer', '')) {
      Vue.set(this.captureLeads[0], 'display', true)
    }
    if (this.passed) {
      this.answered = true
    }
  },

  computed: {
    ...mapState([
      'user'
    ]),

    isEndedConvo () {
      const convoId = this.$route.params.convoId || ''
      const convo = this.$store.getters.getConvoById(convoId)
      if (convo && convo.id && convo.state === 'ended') {
        return true
      }
      return false
    },

    isMobile () {
      return bowser.mobile
    }
  },

  components: {
    Multiselect
  },

  methods: {
    markdownToHtml (text) {
      if (!text) return ''
      return markdown.toHTML(text)
    },

    sendAnswer (name, answer, state, inputType, index) {
      if (this.sending) { return false }
      this.error = ''
      if (!answer && state.require) {
        this.error = this.$t('error_empty')
        return false
      }
      if (answer) {
        if (inputType === 'number' && !isNumber(Number(answer))) {
          this.error = this.$t('error_invalid_number')
        } else if (name === 'emails' && !isEmail(answer)) {
          this.error = this.$t('error_invalid_email')
        } else if (inputType === 'date_time' && isNaN(new Date(answer).getTime())) {
          this.error = this.$t('error_invalid_date')
          this.showCalendar = false
        }
      }
      if (this.error) {
        return false
      }

      let answerListKey = this.answerList.findIndex(item => item.name === name)
      if (answer && answerListKey > -1) {
        let type = this.answerList[index].input_type
        if (type === 'boolean') {
          if (answer.key === 'yes') {
            answer = true
          } else if (answer.key === 'no') {
            answer = false
          }
        } else if (type === 'number') {
          answer = Number(answer)
        } else if (type === 'datetime') {
          answer = new Date(answer)
        }
        Vue.set(this.answerList[answerListKey], 'answer', JSON.stringify(answer))
        Vue.set(this.answerList[answerListKey], 'answered', +Date.now() * 1000000)
        this.countAnswer++
        this.stepId = index
      }
      if (index < this.captureLeads.length -1) {
        Vue.set(this.captureLeads[index], 'display', false)
        let inputAnswer = `input_answer_${this.captureLeads[index + 1].name}`

        Vue.set(this.captureLeads[index + 1], 'display', true)
        if (objectPath.get(this.$refs, `${inputAnswer}.0`, '')) {
          this.$nextTick(() => {
            this.$refs[inputAnswer][0].focus()
          })
        }
        return
      }
      this.submitFromData()
    },

    convertToView (item) {
      item.state = JSON.parse(item.state)
      if (item.answer) {
        item.answer = JSON.parse(item.answer)
        if (item.input_type === 'boolean') {
          if (item.answer === true) {
            item.answer = this.$t('true')
          } else if (item.answer === false) {
            item.answer = this.$t('false')
          }
        } else if (item.input_type === 'datetime') {
          item.answer = new Date(getMs(item.answer)).toISOString().split('T')[0]
        }
      }
      if (item.name === 'fullname') {
        item.title = this.$t('fullname')
        if (!item.answer) item.placeholder = this.$t('fullname_help')
      } else if (item.name === 'emails') {
        item.title = this.$t('email')
        if (!item.answer) item.placeholder = this.$t('email_help')
      } else if (item.name === 'phones') {
        item.title = this.$t('phones')
        if (!item.answer) item.placeholder = this.$t('phones_help')
      } else if (item.name === 'address') {
        item.title = this.$t('address')
        if (!item.answer) item.placeholder = this.$t('address_help')
      } else {
        if (!item.answer) item.placeholder = item.title
      }
      return item
    },

    submitFromData () {
      this.sending = true
      this.error = ''
      this.sucsess = true
      setTimeout(() => {
        this.answered = true
      }, 3000)

      this.$parent.$emit('answer', {
        messageId: this.messageId,
        answer: this.answerList,
        action: 'capture-lead'
      })
      this.sending = false
    },
  },

  watch: {
    showCalendar (calendar) {
      let calendarDom = umbrella('.flatpickr-calendar', this.$el).first()
      if (!calendarDom) return
      if (calendar) {
        calendarDom.style.display = 'block'
        this.$refs.input_date_time[0].focus()
        return
      }
      calendarDom.style.display = 'none'
    },

    attachments (attachments) {
      if (this.sucsess) return
      let cloneAnswerList = cloneDeep(objectPath.get(this.attachments, 'form.fields', []))
      this.title = cloneDeep(objectPath.get(this.attachments, 'form.title', this.$t('capture_lead_title')))
      this.answerList = cloneDeep(cloneAnswerList)
      this.captureLeads = cloneDeep(cloneAnswerList).map(item => this.convertToView(item))
      if (this.captureLeads.length > 0 && !objectPath.get(this.captureLeads, '0.answer', '')) {
        Vue.set(this.captureLeads[0], 'display', true)
      }
    }
  },

  mounted () {
    let datetime = this.captureLeads.find(item => item.input_type === 'datetime')
    if (this.answered || !datetime) return false
    this.$nextTick(() => {
      let calendar = umbrella('#date-picker', this.$el).first()
      let calendarIframe = umbrella('#date-picker-dom', this.$el).first()
      flatpickr(calendar, {
        allowInput: true,
        altFormat: 'd-m-Y',
        appendTo: calendarIframe,
        onOpen: () => {
          this.showCalendar = true
        },
        onClose: () => {
          this.showCalendar = false
        }
      })
    })
  }
}
</script>
